import { render, staticRenderFns } from "./MemoInboxList.vue?vue&type=template&id=630e54b7&"
import script from "./MemoInboxList.vue?vue&type=script&lang=js&"
export * from "./MemoInboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports